import React, { useEffect, useState } from "react";

import { authConfig, applyStyles } from "../../utils/auth";
import { useParams, useHistory } from "react-router-dom";

import { ArrowLeftOutlined } from "@ant-design/icons";
import PdfViewer from "../../components/PdfViewer";
import { useDraggable } from "react-use-draggable-scroll";

import { Row, Col, Button, Radio } from "antd";
import { LoadingOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { AiOutlineCheck } from "react-icons/ai";
import { FaAward } from "react-icons/fa";
import {
  authProject,
  getDns,
  setItem,
  removeItem,
  getItem,
  getPaymentUser,
  getPaymentGroup,
  formatAmount,
  labelsPerFrequency,
} from "utils";

import Plan from "../../components/Plan";

function SelectPlans({
  plans,
  loading,
  selected,
  setSelected,
  setShowPlans,
  setSelectedFrequency,
}) {
  const ref = React.useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:

  return (
    <>
  
      <Row justify="center">
        {plans.length === 0 && !loading ? (
          <p>Nenhum plano disponível</p>
        ) : (
          <Radio.Group
            onChange={(event) => {
              setSelected(event.target.value);
            }}
            value={selected}
            style={{ display: "block" }}
          >
            <div
              {...events}
              ref={ref}
              className="__signup-embed-plan-container"
            >
              {loading && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    height: "400px",
                  }}
                >
                  <LoadingOutlined
                    style={{ alignSelf: "center", fontSize: 40 }}
                  />
                </div>
              )}

              {plans.map((item) => (
                <Plan
                  {...item}
                  plans={plans}
                  selected={selected === item.id}
                  setSelected={setSelected}
                  id={item.id}
                  key={item.id}
                  planDetails={item.detail}
                  value={item.value}
                  yearlyDiscount={item.yearlyDiscount}
                />
              ))}
            </div>
          </Radio.Group>
        )}
      </Row>
    </>
  );
}

export default function SelectGroup({
  props,
  setSelectedPlan,
  id,
  name,
  yearlyDiscount,
  ...item
}) {
  const [otherComponents, setOtherComponents] = useState(false);
  const [returnToken, setReturnToken] = useState(true);
  const [url, setUrl] = useState("");
  const [logo, setLogo] = useState("");
  const [loading, setLoading] = useState("");
  const [selected, setSelected] = React.useState(null);
  const [selectedFrequency, setSelectedFrequency] = React.useState(null);
  const [showPlans, setShowPlans] = React.useState(false);
  const [plans, setPlans] = React.useState([]);
  const [planDetails, setPlanDetails] = React.useState({});
  const [indicationId, setIndicationId] = useState("");

  const [personType, setPersonType] = React.useState(null);

  const { paymentGroupId } = useParams();

  const { dns, type } = useParams();
  const history = useHistory();

  useEffect(() => {
    removeItem("tk-project");
    removeItem("tk-user");
    removeItem("userEmail");
    removeItem("userPhone");
    removeItem("userId");
    removeItem("privacyPolicy");
    removeItem("termsRepresentation");
    removeItem("termsConditions");
    // removeItem("companyId");
    removeItem("androidAppUrl");
    removeItem("companyName");
    removeItem("iosAppUrl");

    var subdomain = window.location.hostname;

    if (window.location.hostname === "localhost") {
      subdomain = "brm1";
    } else {
      subdomain = subdomain.match(/embed-(.*?)\./)[1];
    }

    applyStyles(subdomain).then(() =>
      authProject(authConfig).then(() => {
        setReturnToken(false);
        const val = getItem("preFilled");
      })
    );
  }, []);

  const handleClickFirst = (type) => {
    setPersonType(type);
  };

  async function getPlans() {
    setLoading(true);

    const companyId = await getItem("companyId");

    const {
      data: { data: dataPlans },
    } = await getPaymentUser({
      companyId,
      ...(personType === "legalPerson" && { legalPerson: true }),
    });

    const sortedPlans = sortPlans(dataPlans);
    setPlans(sortedPlans);
    setLoading(false);
  }

  function sortPlans(dataPlans, frequency = "MONTHLY") {
    let sortedPlans = dataPlans;
    let discount;

    //MOSTRA O VALOR EM ORDEM
    function sortFunc(a, b) {
      const aMonth = a.paymentTypes.find((i) => i.frequency === "MONTHLY");
      const bMonth = b.paymentTypes.find((i) => i.frequency === "MONTHLY");

      return aMonth?.value - bMonth?.value;
    }

    sortedPlans = dataPlans.filter(p => p).sort(sortFunc);

    /// CASO SEJA MENSAL OU ANUAL
    sortedPlans = sortedPlans.map((i) => {
      const yearlyPayment = i.paymentTypes.find(
        (i) => i.frequency === "YEARLY"
      );
      const monthlyPayment = i.paymentTypes.find(
        (i) => i.frequency === "MONTHLY"
      );

      if (yearlyPayment && monthlyPayment && frequency === "YEARLY") {
        discount = {
          value: monthlyPayment?.value * 12 - yearlyPayment?.value,
          percentage: Math.abs(
            Math.ceil((monthlyPayment?.value / yearlyPayment?.value) * 100)
          ),
        };

        return {
          ...i,
          frequency: discount ? "YEARLY" : "MONTHLY",
          yearlyDiscount: discount,
          value: yearlyPayment?.value,
        };
      } else if (!monthlyPayment) {
        return {
          ...i,
          frequency: "YEARLY",
          value: yearlyPayment?.value,
        };
      } else {
        return {
          ...i,
          frequency: "MONTHLY",
          value: monthlyPayment?.value,
        };
      }
    });

    return sortedPlans;
  }

  useEffect(() => {
    if (personType) {
      getPlans();
    }
  }, [personType]);

  useEffect(() => {
    setPlans(sortPlans(plans, selectedFrequency));

    const monthlyPlans = plans.filter((plan) =>
    plan.paymentTypes.some((type) => type.frequency === "MONTHLY")
  );

  if (monthlyPlans.length > 0) {
    setPlans(sortPlans(monthlyPlans, selectedFrequency));
  } else {

    const yearlyPlans = plans.filter((plan) =>
      plan.paymentTypes.some((type) => type.frequency === "YEARLY")
    );
    setPlans(sortPlans(yearlyPlans, selectedFrequency));
  }

  console.log(monthlyPlans);
  }, [selectedFrequency]);

  return (
    <div className="__auth-background">
      <div
        className="__auth-content __auth-flex-row"
        style={{ paddingRight: 0 }}
      >
        <div
          className="__auth-content __auth-flex-row"
          style={{ paddingRight: 0 }}
        >
          <div className="__auth-flex-column __auth-flex-1">
            <div className="__auth-height-100 __auth-image-background"></div>
          </div>
          <div
            className={`__auth-flex-column __auth-flex-4`}
            style={{ overflowX: "auto" }}
          >
            <div className="__auth-header">
              <div className="align-items-center">
                <div className="__auth-header-logo">
                  <div className="__auth-header-main-logo-container">
                    <div className="main-logo"></div>
                  </div>
                </div>
              </div>
            </div>
            <div key="formPersonal">
              {!showPlans ? (
                <>
                  <Row justify="center">
                    <Col>
                      <h1>Planos</h1>
                    </Col>
                  </Row>
                  <Row justify="center">
                    <Col className="__auth-test">
                      <button
                        type="button"
                        className="__auth-button-primary-personal __auth-button-type-person-personal"
                        onClick={() => {
                          handleClickFirst("personal");
                          setShowPlans(true);
                        }}
                        disabled={loading}
                      >
                        {/* <img src=""/> */}
                        {loading ? (
                          <LoadingOutlined />
                        ) : (
                          <span>Pessoa Fisica</span>
                        )}
                      </button>

                      <button
                        type="button"
                        className="__auth-button-primary-personal __auth-button-type-person-legalPerson "
                        onClick={() => {
                          handleClickFirst("legalPerson");
                          setShowPlans(true);
                        }}
                        disabled={loading}
                      >
                        {loading ? (
                          <LoadingOutlined />
                        ) : (
                          <span>Pessoa Juridica</span>
                        )}
                      </button>
                    </Col>
                  </Row>
                </>
              ) : plans.length === 0 && !loading ? (
                <Row justify="center">
                  <Col style={{ marginBottom: "10%", marginTop: "5%" }}>
                    <h2>Nenhum plano disponível</h2>
                  </Col>
                </Row>
              ) : (
                <SelectPlans
                  {...{
                    plans,
                    loading,
                    selected,
                    setSelected,
                    setShowPlans,
                    setSelectedFrequency,
                  }}
                />
              )}

              {showPlans && (
                <Row>
                  <Col xs={12}>
                    <button
                      type="button"
                      className={"__auth-button-back"}
                      onClick={() => {
                        setShowPlans(false);
                        setPlans([]);
                        setPersonType(null);
                      }}
                      disabled={loading}
                    >
                      Voltar
                    </button>
                  </Col>
                  <Col xs={12}>
                    <button
                      type="button"
                      className={"__auth-button-next"}
                      onClick={() => {
                        history.push(`/${personType}/signup/${selected}`);
                      }}
                      disabled={plans.length === 0}
                    >
                      {loading ? <LoadingOutlined /> : "Próximo"}
                    </button>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
